import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import subscriptionService from "../../api/services/subscriptionService";
import toast from "react-hot-toast";
import Loading from "../../components/Loading";

const Subscription = () => {
  const [activeTab, setActiveTab] = useState("All");
  const [subscriptionData, setSubscriptionData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const tabs = [
    { key: "All", label: "All" },
    { key: "Weekly", label: "Weekly" },
    { key: "Monthly", label: "Monthly" },
  ];

  useEffect(() => {
    const getSubscriptions = async () => {
      try {
        setIsLoading(true);
        const response =
          await subscriptionService.getAllPurchasedSubscriptions();
        if (response?.responseCode === 200) {
          setSubscriptionData(response?.subscriptions);
          // toast.success(response?.message);
        } else {
          toast.error(response?.message);
        }
      } catch (error) {
        toast.error("Failed to fetch subscriptions");
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    getSubscriptions();
  }, []);

  // ✅ Filter based on tab (Weekly / Monthly / All)
  const filteredByTab =
    activeTab === "Weekly"
      ? subscriptionData.filter((data) => data.duration === "Week")
      : activeTab === "Monthly"
      ? subscriptionData.filter((data) => data.duration === "Month")
      : subscriptionData;

  // 🔍 Filter by search (name or email)
  const tableData = filteredByTab.filter((sub) => {
    const fullName = `${sub.firstName || ""} ${
      sub.lastName || ""
    }`.toLowerCase();
    const email = sub.email?.toLowerCase() || "";
    const term = searchTerm.toLowerCase();
    if (email.endsWith("@naseebimail.com")) return false;
    return fullName.includes(term) || email.includes(term);
  });

  return (
    <div className="p-4 w-full">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          {/* 🔹 Header Section */}
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-4">
        {/* Tabs */}
        <div className="flex gap-3">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`px-4 py-2 rounded ${
                activeTab === tab.key
                  ? "bg-red-500 text-white shadow"
                  : "bg-gray-100 text-gray-700"
              }`}>
              {tab.label}
            </button>
          ))}
        </div>

        {/* 🔍 Search Bar */}
        <input
          type="text"
          placeholder="Search by name or email..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="border border-gray-300 rounded-md px-4 py-2 w-full md:w-64 focus:outline-none focus:ring-2 focus:ring-red-400"
        />
          </div>

          {/* 🔹 Table */}
          <div className="overflow-x-auto bg-white shadow rounded-lg">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-gray-100 text-gray-700">
              <th className="p-3 border-b">User Name</th>
              <th className="p-3 border-b">Email</th>
              <th className="p-3 border-b">Plan</th>
              <th className="p-3 border-b">Duration</th>
              <th className="p-3 border-b">Duration (Days)</th>
              <th className="p-3 border-b">Price</th>
              <th className="p-3 border-b">Start Date</th>
              <th className="p-3 border-b">End Date</th>
            </tr>
          </thead>
          <tbody>
            {tableData.length > 0 ? (
              tableData.map((sub) => (
                <tr key={sub.userSubscriptionId} className="hover:bg-gray-50">
                  <td className="p-3 border-b font-semibold">
                    {sub.firstName} {sub.lastName}
                  </td>
                  <td className="p-3 border-b text-gray-600">{sub.email}</td>
                  <td className="p-3 border-b">{sub.name}</td>
                  <td className="p-3 border-b">{sub.duration}</td>
                  <td className="p-3 border-b">{sub.duration_days}</td>
                  <td className="p-3 border-b">
                    {sub.currency} {sub.amount}
                  </td>
                  <td className="p-3 border-b">
                    {sub.start_date
                      ? new Date(sub.start_date).toLocaleDateString()
                      : "-"}
                  </td>
                  <td className="p-3 border-b">
                    {sub.end_date
                      ? new Date(sub.end_date).toLocaleDateString()
                      : "-"}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="p-4 text-center text-gray-500">
                  No subscriptions found for "{activeTab}" or search term "
                  {searchTerm}".
                </td>
              </tr>
            )}
          </tbody>
        </table>
          </div>
        </>
      )}
    </div>
  );
};

export default Subscription;
